import angular from 'angular';
import clientSearch from './clientSearch';

export default angular
  .module('components.clientSearch', [])
  .component('clientSearch', clientSearch).name;
